'use client';

import newsData from '/public/data/newsroom.json';
import { BookDemoButton } from '@/components/ui';
import { useTranslation } from "@/hooks/useTranslation";
const NEWS = newsData || [];
const HOT_PRESS = NEWS.slice(0, 4);
export default function NewsroomPage() {
  const {
    t
  } = useTranslation();
  return <>
      {/* Hero */}
      <section style={{
      background: '#fff',
      position: 'relative',
      overflow: 'hidden',
      padding: 'var(--hero-pad)'
    }}>
        <div className="lb-hero-grad" style={{
        position: 'absolute',
        inset: 0
      }} />
        <div className="container" style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center'
      }}>
          <h1 className="lb-h1" style={{
          marginBottom: 16
        }}>{t("newsroom.locobuzz_newsroom")}</h1>
          <p style={{
          fontSize: 17,
          color: '#4B5563',
          maxWidth: 520,
          margin: '0 auto',
          lineHeight: 1.7
        }}>
            {t("newsroom.stay_updated_with_the_latest_news_i")}
          </p>
        </div>
      </section>

      {/* Hot off the press + featured */}
      <section className="lb-section-alt">
        <div className="container">
          <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: 40,
          alignItems: 'start'
        }}>
            {/* Featured */}
            {NEWS[0] && <a href={NEWS[0].url} target="_blank" rel="noopener noreferrer" style={{
            textDecoration: 'none'
          }}>
                <div className="lb-card" style={{
              padding: 0,
              overflow: 'hidden'
            }}>
                  <div style={{
                height: 240,
                background: '#1F2937',
                position: 'relative',
                overflow: 'hidden'
              }}>
                    <img src={NEWS[0].cover} alt="" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  padding: 40,
                  opacity: 0.8
                }} />
                  </div>
                  <div style={{
                padding: 24
              }}>
                    <span style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#0077FF',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>{NEWS[0].category}</span>
                    <h2 style={{
                  fontFamily: "'Inter',sans-serif",
                  fontWeight: 700,
                  fontSize: 20,
                  color: '#111827',
                  marginTop: 8,
                  marginBottom: 8,
                  lineHeight: 1.4
                }}>{NEWS[0].title}</h2>
                    <div style={{
                  fontSize: 13,
                  color: '#9CA3AF'
                }}>{NEWS[0].outlet} • {NEWS[0].date}</div>
                  </div>
                </div>
              </a>}
            {/* Hot off the press */}
            <div>
              <h3 style={{
              fontFamily: "'Inter',sans-serif",
              fontWeight: 700,
              fontSize: 16,
              color: '#111827',
              marginBottom: 16,
              paddingBottom: 12,
              borderBottom: '1px solid #E5E7EB'
            }}>{t("newsroom.hot_off_the_press")}</h3>
              {HOT_PRESS.map((item, i) => <a key={i} href={item.url} target="_blank" rel="noopener noreferrer" style={{
              textDecoration: 'none'
            }}>
                  <div style={{
                display: 'flex',
                gap: 12,
                marginBottom: 16,
                paddingBottom: 16,
                borderBottom: '1px solid #F3F4F6'
              }}>
                    <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 8,
                  background: '#F8FAFF',
                  overflow: 'hidden',
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                      <img src={item.cover} alt="" loading="lazy" decoding="async" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    padding: 6
                  }} />
                    </div>
                    <p style={{
                  fontSize: 13,
                  color: '#374151',
                  lineHeight: 1.5,
                  margin: 0,
                  fontWeight: 500
                }}>{item.title}</p>
                  </div>
                </a>)}
            </div>
          </div>
        </div>
      </section>

      {/* Headlines */}
      <section className="lb-section">
        <div className="container">
          <h2 className="lb-h2" style={{
          marginBottom: 32
        }}>{t("newsroom.headlines_highlights")}</h2>
          <div className="lb-grid-3">
            {NEWS.map((item, i) => <a key={i} href={item.url} target="_blank" rel="noopener noreferrer" style={{
            textDecoration: 'none'
          }}>
                <div className="lb-card" style={{
              height: '100%'
            }}>
                  <div style={{
                height: 120,
                borderRadius: 10,
                overflow: 'hidden',
                background: '#F8FAFF',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16
              }}>
                    <img src={item.cover} alt="" loading="lazy" decoding="async" style={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  objectFit: 'contain'
                }} />
                  </div>
                  <span style={{
                fontSize: 10,
                fontWeight: 700,
                color: '#0077FF',
                background: '#EBF4FF',
                padding: '2px 8px',
                borderRadius: 4,
                textTransform: 'uppercase',
                letterSpacing: '0.3px'
              }}>{item.category}</span>
                  <h3 style={{
                fontFamily: "'Inter',sans-serif",
                fontWeight: 600,
                fontSize: 14,
                color: '#111827',
                margin: '10px 0 8px',
                lineHeight: 1.5
              }}>{item.title}</h3>
                  <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 12,
                color: '#9CA3AF'
              }}>
                    <img src={item.outletLogo} alt={item.outlet} loading="lazy" decoding="async" style={{
                  height: 16,
                  width: 'auto',
                  objectFit: 'contain'
                }} onError={e => e.currentTarget.style.display = 'none'} />
                    <span>{item.outlet}</span>
                    <span>•</span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* PR contact */}
      <section style={{
      background: 'linear-gradient(135deg,#EBF4FF,#F0F4FF)',
      padding: '60px 0',
      borderTop: '1px solid #BDD9FF'
    }}>
        <div className="container">
          <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 40,
          alignItems: 'center'
        }}>
            <div>
              <h2 className="lb-h2" style={{
              marginBottom: 12
            }}>{t("newsroom.lets_talk")}</h2>
              <p style={{
              fontSize: 16,
              color: '#4B5563',
              marginBottom: 24
            }}>{t("newsroom.got_pressrelated_queries_wed_love_t")}</p>
              <a href="mailto:pr@locobuzz.com" style={{
              fontSize: 15,
              fontWeight: 600,
              color: '#0077FF',
              textDecoration: 'none'
            }}>{t("newsroom.prlocobuzzcom")}</a>
            </div>
            <div>
              <h2 className="lb-h2" style={{
              marginBottom: 16
            }}>{t("newsroom.curious_to_know_why_were_buzzing_ev")}</h2>
              <p style={{
              fontSize: 15,
              color: '#4B5563',
              marginBottom: 24
            }}>{t("newsroom.fill_in_the_information_and_get_a_d")}</p>
              <BookDemoButton label={t("newsroom.book_a_demo")} />
            </div>
          </div>
        </div>
      </section>
    </>;
}